import React from 'react';
import styled from 'styled-components';
import "./hellofooter.css"
import { Link } from 'react-router-dom';
import { BRAND, BRAND_LINK } from '../../../Helper';
const REACT_APP_LG_LOGO = process.env.REACT_APP_LG_LOGO


const Container = styled.div`
  background-color: rgb(27, 29, 33);
  padding-bottom: 20px;
`;

const FooterWrapper = styled.div`
  background-color: #000;
  color: #ffffff;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  font-family: Arial, sans-serif;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Section = styled.div`
  width: 50%;
  padding-left: 40px;
  justify-content: center;
  color: #8E969f;
  font-family: Arial, sans-serif !important;
  font-size: 14px;

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0;
    margin-bottom: 20px;
  }
`;

const Logo = styled.img`
  width: 150px;
  height: auto;
`;

const Description = styled.div`
  font-size: 14px;
  margin-top: 10px;
  color: #7F8893;
`;

const LinkHeader = styled.h3`
  color: #8E969f;
  font-family: Arial, sans-serif !important;
  font-size: 12px;
`;

const StyledLink = styled.a`
  color: #8E969f;
  text-decoration: none;
  font-size: 12px;
  margin-bottom: 5px;
  display: block;
  &:hover {
    text-decoration: underline;
  }
`;

const CurrencyIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`;

const Flex = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const FlexWrap = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 0.5px solid #8E969f;
  margin: 16px 0;
  width: 100%;
  height: 0;
`;

const BottomFlexWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 20px 0px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const HelloFooter = () => {

  const awards = [
    "/assets/bcimages/bcfooter/bc-award-1.webp",
   "/assets/bcimages/bcfooter/bc-award-2.webp",
    "/assets/bcimages/bcfooter/bc-award-3.webp",
   "/assets/bcimages/bcfooter/bc-award-4.webp",
   "/assets/bcimages/bcfooter/bc-award-5.webp",
   "/assets/bcimages/bcfooter/bc-award-6.webp",
   "/assets/bcimages/bcfooter/bc-award-7.webp",
   "/assets/bcimages/bcfooter/bc-award-8.webp",
  ];

  const sponsors = [
    { id: 1, href: "https://sigma.world/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-1.webp", alt: "Sponsor 1", width: "94px" },
    { id: 2, href: "https://www.responsiblegambling.org/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-2.webp", alt: "Sponsor 2", width: "104px" },
    { id: 3, href: "https://www.gamcare.org.uk/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-3.webp", alt: "Sponsor 3", width: "125px" },
    { id: 4, href: "https://betblocker.org/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-4.webp", alt: "Sponsor 4", width: "180px" },
    { id: 5, href: "/help/protect-minors", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-5.webp", alt: "Sponsor 5", width: "50px" },
    { id: 6, href: "https://cloud9.gg/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-7.webp", alt: "Sponsor 6", width: "52px" },
    { id: 7, href: "https://www.lcfc.com/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-6.webp", alt: "Sponsor 7", width: "45px" },
    { id: 8, href: "https://www.jasonderulo.com/", imgSrc: "/assets/bcimages/bcfooter/bc-sponser-8.webp", alt: "Sponsor 8", width: "100px" },
  ];

  return (
    <Container>
      <div className="bc-game-awards-main">
        {awards.map((award, index) => (
          <div key={index} className="bc-game-awards">
            <img src={award} alt={`Award ${index + 1}`} />
          </div>
        ))}
      </div>

      <div className='bc-game-sponsers-main' style={{display: "block"}}>
        <div className='bc-game-sponsers'>
          <div className='bc-game-sponsers-grid-1'>
            {sponsors.map((sponsor) => (
              <StyledLink
                key={sponsor.id}
                rel="noopener noreferrer"
                href={"#"}
                className="inactive"
              >
                <img src={sponsor.imgSrc} alt={sponsor.alt} />
              </StyledLink>
            ))}
          </div>
        </div>
      </div>

      <div className='main-footer-container'>
        <div className="main-footer-contant">
          <h4>Casino</h4>
          <ul>
            <li><Link to="/casino">Casino</Link></li>
            {/* <li><Link to="/casino/originals">Originals</Link></li> */}
            <li><Link to="/casino/hot-games">Hot Games</Link></li>
            <li><Link to="/casino/slots">Slots</Link></li>
            <li><Link to="/casino/live-casino">Live Casino</Link></li>
            <li><Link to="/casino/providers">Providers</Link></li>
          </ul>
        </div>

        {/* <div className="main-footer-contant">
          <h4>Sports</h4>
          <ul>
            <li><Link to="/casino/sports">Bti Sports</Link></li>
            <li><Link to="/casino/sports">IA</Link></li>
          </ul>
        </div> */}

        <div className="main-footer-contant">
          <h4>Promo</h4>
          <ul>
            <li><Link to="/vip-club">VIP Club</Link></li>
            <li><Link to="/bonus">Bonus</Link></li>
            <li><Link to="/affiliate">Affiliate</Link></li>
            <li><Link to="/promotions">Promotions</Link></li>
            <li><Link to="/affiliate">Refer a Friend</Link></li>
          </ul>
        </div>

        <div className="main-footer-contant">
          <h4>Support/Legal</h4>
          <ul>
            <li><Link to="/provably-fair">Provably Fair</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/provably-fair">Privacy Policy</Link></li>
            <li><Link to="/provably-fair">Terms Of Service</Link></li>
            {/* <li><Link to="/app">APP</Link></li>
            <li><Link to="/live-support">Live Support</Link></li> */}
          </ul>
        </div>

        <div className="main-footer-contant">
          <h4>About Us</h4>
          <ul>
            <li><Link to="/provably-fair">News</Link></li>
            <li><Link to="/provably-fair">Work with Us</Link></li>
            <li><Link to="/provably-fair">Business Contacts</Link></li>
            <li><Link to="/provably-fair">Help Desk</Link></li>
          </ul>
        </div>
      </div>

      <div className='bcgame-footer-bottom-main'>
        <div className='bcgame-footer-bottom'>
          <div className='bcgame-footer-bottom-logo'>
            <img src={REACT_APP_LG_LOGO} />
          </div>
          <div className='bcgame-footer-about-img'>
            <img src='/assets/bcimages/bcfooter/bc-footer-about-bcapp.png' />
          </div>
          <div className='bcgame-footer-about-bcgame'>
            <p>A multi-award winning crypto casino. With a player-centric approach, {BRAND_LINK} is able to satisfy millions of gamblers across the globe. {BRAND_LINK} has its priority set on its community, ensuring an everlasting and endlessly entertaining gambling experience.</p>
            <p>Your use of and access to {BRAND_LINK} signifies that you fully understand and agree to be legally bound by the contents of our Terms of Service and Responsible Gaming Policy</p>
            <p>Crypto trading is not gambling by definition, therefore it is not covered by our gaming license.</p>
          </div>
          <div>
            <div className='bcgame-footer-about-bcapp'>
              <p>{BRAND_LINK} is operated by Twocent Technology Limited, a limited liability company registered in Belize with company registration number 000041939, with registered address at Sea Urchin Street, San Pedro, Ambergris Caye, Belize. {BRAND_LINK} is licensed and regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros and operates under License No. ALSI-202410011-FI1. {BRAND_LINK} has passed all regulatory compliance and is legally authorized to conduct gaming operations for any and all games of chance and wagering.</p>
            </div>
          </div>
        </div>
        <span>{BRAND} @ 2025 All Rights Reserved</span>
      </div>
    </Container>
  );
};

export default HelloFooter;
